<template>
	<span v-if="value">
		{{ value[$lang.current] }}
	</span>
</template>
<script>
export default {
    props: ['value'],
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/table/value/Translatable.vue